import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { StoreService } from '@services/store/store.service';
import { ApiService } from '@services/api/api.service';
import { closePanels } from '../../app/modules/client/utils';
import { defaultLogo, defaultQuickPages } from '../../app/modules/client/default-ui-setting-values';
import { ICustomer, IUser, defaultUISettings } from '@app/models/user';
import { accessRole } from '@app/models/access-role';
import revision from '@app/app.revision';
import { LayoutService, ColorScheme } from 'src/app/layout/service/app.layout.service';
import { MenuItem } from 'primeng/api';
import { map } from 'rxjs';
import { timezones } from '@app/modules/client/user/user-edit/timezone';
import { ToastrService } from '@app/services/toastr/toastr.service';
import { defaultAvatar, defaultIncognitoAvatar } from '../../app/modules/client/default-ui-setting-values';
@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopBarComponent {
  readonly workspaceNavigation = true;

  menu: MenuItem[] = [];

  @ViewChild('searchinput') searchInput!: ElementRef;
  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('profileMenu') profileMenu!: ElementRef;
  @ViewChild('profileButton') profileButton!: ElementRef;
  searchActive = false;

  // Basic User Settings
  title: any; // title of project
  userId: number; // user id
  // colorScheme = 'light';      // theme mode (dark, light)
  user: IUser; // user information
  quickPages = []; // quick page links
  avatar = ''; // avatar image data(base64)
  incognitoAvatar = ''; // incognito avatar image data(base64)
  get displayLogo(): string {
    return this.logoImg === defaultLogo ? 'assets/images/ecms-wordmark.svg' : this.logoImg;
  }
  logoImg: string = defaultLogo; // logo image data(base64)
  versionNumber = revision;
  currentRoute = '';
  isSuperAdmin = false;
  currentTimezone: string;
  isSorted = false;
  balance = 0;

  placeholder = 'loading';

  menuItems!: MenuItem[];

  userInfo = {
    name: '',
    avatarName: '',
    email: '',
    role: 'Administrator',
    accountName: '',
    accountID: '',
    supportPIN: '',
    accountingType: 0,
  };

  selectedCustomer: any = {};
  customerList: ICustomer[] = [];

  isCustomerPanel = false;
  impersonateToken: any;
  isCustomerAdmin = false;

  constructor(
    private route: Router,
    private routerdata: ActivatedRoute,
    public store: StoreService,
    private api: ApiService,
    private toastrService: ToastrService,
    public layoutService: LayoutService,
    private renderer: Renderer2
  ) {
    this.title = route.url;

    // debugger
    this.title = this.title.replace(/\//g, '');
    this.title = this.title.toUpperCase();
    // this.defaultUiSettings = layoutService.getDeafultUISettings();
  }

  async ngOnInit() {
    this.currentRoute = this.route.url;

    this.route.events.subscribe(value => {
      if (value instanceof NavigationEnd) {
        this.currentRoute = this.route.url;
        this.isCustomerPanel = this.currentRoute.includes('customer-panel') ? true : false;

        if (this.isCustomerPanel && !this.customerList.length) {
          this.api
            .getAllCustomerList()
            .pipe(
              map((data: any) => {
                data.unshift({ id: '', companyName: 'Select a Customer' });
                return data;
              })
            )
            .subscribe(customers => (this.customerList = customers));
        }
      }
    });

    await new Promise<void>(resolve => {
      const mainUserInterval = setInterval(() => {
        if (this.store.getUser() && this.store.getGuiVisibility()) {
          clearInterval(mainUserInterval);
          resolve();
        }
      }, 100);
    });

    this.routerdata.data.subscribe(d => {
      this.title = d.title;
      this.title = this.title.replace(/\//g, '');
      this.title = this.title.toUpperCase();
    });

    // set theme mode and logo image
    this.store.state$.subscribe(async state => {
      if (state.token) {
        this.userId = state.token.userId;
      }
      this.isSuperAdmin = state.userPermissions?.isSuperAdmin;
      this.isCustomerAdmin = state.userPermissions?.isCustomerAdmin;
      if (state.token && state.user && state.guiVisibility) {
        this.user = state.user;

        this.userInfo.name = this.user.firstName + ' ' + this.user.lastName;
        if (this.user.firstName?.length > 0) this.userInfo.avatarName = this.user.firstName.substr(0, 1);
        if (this.user.lastName?.length > 0) this.userInfo.avatarName += this.user.lastName.substr(0, 1);
        this.userInfo.email = this.user.email;

        if (this.user.Customer) {
          this.userInfo.accountName = this.user.Customer.companyName;
          this.userInfo.accountID = this.user.Customer.billingId == null ? '' : this.user.Customer.billingId;
          this.userInfo.accountingType = this.user.Customer.accounting_type;
        }

        if (
          this.user.hasOwnProperty('DashRoleMapping') &&
          Array.isArray(this.user.DashRoleMapping) &&
          this.user.DashRoleMapping.length > 0 &&
          this.user.DashRoleMapping[0].hasOwnProperty('DashRole')
        ) {
          this.userInfo.role = this.user.DashRoleMapping[0].DashRole.name;
        }

        let uiSettings =
          typeof state.user.uiSettings === 'string'
            ? JSON.parse(state.user.uiSettings)
            : JSON.parse(JSON.stringify(state.user.uiSettings));

        // Update Balance if any
        if (this.user.Customer && this.user.Customer.hasOwnProperty('balance'))
          this.balance = this.user.Customer['balance'];
        else this.balance = 0;

        // Default UI Settings if none
        if (!uiSettings) {
          uiSettings = defaultUISettings;
          this.colorScheme = uiSettings.colorScheme;
          this.user.uiSettings = JSON.stringify(uiSettings);

          this.store.storeUser(this.user);
          try {
            this.api.updateUser(this.user).subscribe(res => {
              console.debug('User updated:', res);
            });
          } catch (e) {
            console.debug('Unable to update user:', e);
          }
        }

        // if the ui setting information of the user exists
        if (uiSettings) {
          this.applyTheme(uiSettings);
          // Set user current Timezone
          const timezoneName = uiSettings?.timezone?.length
            ? uiSettings.timezone
            : new Date().toLocaleDateString('en-US', { timeZoneName: 'long' }).substring(12);
          const currentTimezone = timezones.find(x =>
            x.value.replace(/\s/g, '').toLowerCase().includes(timezoneName.replace(/\s/g, '').toLowerCase())
          );
          const timezoneParts = currentTimezone ? currentTimezone.text.split('(') : '';
          this.currentTimezone = timezoneParts.length ? timezoneParts[1].split(')')[0] : '';
          // set custom logo image
          if (uiSettings.customLogoImg != undefined) this.logoImg = uiSettings.customLogoImg;

          this.quickPages = JSON.parse(JSON.stringify(defaultQuickPages)); // quick page links

          // set quick page links
          if (uiSettings.customQuickPageEnables != undefined) {
            for (let i = 0; i < uiSettings.customQuickPageEnables.length; i++) {
              if (this.quickPages[i] != undefined) this.quickPages[i].isQuick = uiSettings.customQuickPageEnables[i];
            }
          }

          // check quickPages that belongs to the user's role permission
          // if (this.store.getUserType() != CMSUserType.superAdmin) {
          //   for (let i = this.quickPages.length - 1; i >= 0; i--) {
          //     let permission = PERMISSION_TYPE_DENY;
          //     if (this.user.DashRoleMapping && this.user.DashRoleMapping.length > 0) {
          //       for (const v of state.guiVisibility) {
          //         if (GUI_VISIBILITY_MATCH[v.GuiSection.name] == this.quickPages[i].title) {
          //           permission = v.GuiPermission.name;
          //           break;
          //         }
          //       }
          //     }

          //     if (permission == PERMISSION_TYPE_DENY) this.quickPages[i].isQuick = false;
          //   }
          // }

          const quickPages = JSON.parse(JSON.stringify(this.quickPages));
          await quickPages.sort((page1, page2) => page1.isQuick - page2.isQuick);
          this.quickPages = quickPages.filter(page => page.isQuick);

          // set custom avatar
          if (uiSettings.customAvatar != undefined) this.avatar = uiSettings.customAvatar;
          if (this.avatar == '' || !this.avatar) this.avatar = defaultAvatar;

          // set incognito avatar
          if (uiSettings.incognitoAvatar != undefined) this.incognitoAvatar = uiSettings.incognitoAvatar;
          if (this.incognitoAvatar == '' || !this.incognitoAvatar) this.incognitoAvatar = defaultIncognitoAvatar;

          // set the default color scheme
          if (uiSettings.colorScheme) this.colorScheme = uiSettings.colorScheme;
        }
        this.setMenuItems();
      }
    });

    // subscribe for balance update
    this.store.getBalance().subscribe((value: any) => {
      if (value && this.user?.Customer) {
        this.user.Customer.balance = value;
        this.store.storeUser(this.user);
        this.balance = value;
      }
    });

    this.store.getImpersonateToken().subscribe((token: any) => {
      this.impersonateToken = token;
    });
  }

  ngAfterViewInit() {
    this.renderer.listen('document', 'click', (event: any) => {
      this.handleClickOutside(event);
    });
  }

  get colorScheme(): ColorScheme {
    return this.layoutService.config().colorScheme;
  }
  set colorScheme(_val: ColorScheme) {
    if (_val == 'dark') {
      this.layoutService.config.update(config => ({
        ...config,
        layoutTheme: 'colorScheme',
      }));
    }
    this.layoutService.config.update(config => ({
      ...config,
      colorScheme: _val,
    }));
  }

  closeMenu() {
    this.renderer.addClass(this.profileMenu.nativeElement, 'hidden');
  }

  showMenu() {
    this.renderer.removeClass(this.profileMenu.nativeElement, 'hidden');
  }

  handleClickOutside(event?: MouseEvent) {
    const clickedInsideMenu = this.profileMenu?.nativeElement.contains(event.target);
    const clickedOnButton = this.profileButton?.nativeElement.contains(event.target);

    if (!clickedInsideMenu && !clickedOnButton) {
      this.closeMenu();
    }
  }

  setActiveQuickButton(el) {
    if (el?.classList.contains('active-btn')) {
      let color = window.getComputedStyle(el)?.getPropertyValue('color');
      color = color.replace(')', ', 0.5)');
      return color;
    }
  }

  setMenuItems() {
    const { isSuperAdmin } = this.store.getUserPermissions();
    const MENU_ITEMS: any = [
      {
        label: this.userInfo.accountName,
        items: [
          {
            label: `<div class="custom-menu-list-item">
                  <p>ACCOUNT ID: <span>${this.userInfo.accountID}</span></p>
                  <p class="hidden">SUPPORT PIN: <span>${this.userInfo.supportPIN}</span></p>
                  <p>BALANCE: <span>${this.balance} | currency: ${this.user?.Customer?.currency || 'USD'};
                  }</span></p>
                  </div>`,
            styleClass: 'no-hover',
            escape: false,
            icon: 'pi pi-fw pi-user-edit',
            routerLink: '/service/user/account',
            visible: isSuperAdmin ? false : true,
          },
          {
            separator: true,
            visible: isSuperAdmin ? false : true,
          },

          {
            label: 'User Profile',
            icon: 'pi pi-fw pi-user-edit',
            routerLink: '/service/user/edit/' + this.userId,
            escape: true,
          },
          // {
          //   label: 'Account Settings', icon: 'pi pi-fw pi-cog', routerLink: '/service/user/edit/' + this.userId
          // },
          {
            label: 'Billing Settings',
            icon: 'pi pi-fw pi-wallet',
            routerLink: '/service/billing/settings',
            visible: isSuperAdmin ? false : true,
          },
          {
            label: this.colorScheme == 'dark' ? 'Light Mode' : 'Dark Mode',
            icon: 'pi pi-fw pi-send',
            command: event => {
              this.toggleMode();
            },
          },
          {
            separator: true,
          },
          {
            label: 'Sign Out',
            icon: 'pi pi-fw pi-sign-out',
            command: event => {
              this.onSignout();
            },
          },
        ],
      },
    ];
    this.menuItems = MENU_ITEMS;
  }

  toggleMode() {
    this.colorScheme = this.colorScheme == 'dark' ? 'light' : 'dark';
    this.setMenuItems();
    const user = this.store.getUser();
    if (user) {
      const uiSettings =
        typeof user.uiSettings === 'string' ? JSON.parse(user.uiSettings) : JSON.parse(JSON.stringify(user.uiSettings));
      uiSettings.colorScheme = this.colorScheme;
      user.uiSettings = JSON.stringify(uiSettings);
      this.store.storeUser(user);
      this.api.updateUser(user).subscribe(
        res => {
          if (res) {
            this.showSuccess('UI settings successfully updated.');
          } else {
            this.showWarning('Failed to update UI settings.');
          }
        },
        error => {
          console.debug('Toggle Mode Error', error);
        }
      );
    }
  }

  applyTheme(settings) {
    let selectedThemeKey = settings.colorScheme == 'dark' ? settings?.darkTheme?.key : settings?.lightTheme?.key;
    selectedThemeKey = selectedThemeKey?.includes('md-light-')
      ? selectedThemeKey?.replace('md-light-', '')
      : selectedThemeKey?.replace('md-dark-', '');
    this.layoutService.config.update(config => ({
      ...config,
      theme: selectedThemeKey,
    }));
  }

  get isAdmin() {
    //return false;
    return this.store.getUserPermissions()?.isSuperAdmin === true;
  }

  get isAgent(): boolean {
    return accessRole(this.store.getUser()) === 'Agent';
  }

  /**
   * this is called when the user clicks sign out button
   */
  onSignout = () => {
    this.api.logout().subscribe(
      res => {
        this.store.clearStoreAndLogout();
      },
      err => {
        this.store.clearStoreAndLogout();
        this.showError(err.error.message);
      }
    );
  };

  /**
   * this is called when the user clicks the quick page icon
   */
  onClickQuickPage = () => {
    closePanels();
  };

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  activateSearch() {
    this.searchActive = true;
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }

  deactivateSearch() {
    this.searchActive = false;
  }

  removeTab(event: MouseEvent, item: MenuItem, index: number) {
    event.preventDefault();
  }

  get logo(): string {
    return 'assets/images/cms-logo2.png';
  }

  get tabs(): MenuItem[] {
    return [];
  }

  redirectToLogin() {
    this.route.navigate(['/login']);
  }

  deimpersonate() {
    const impersonateToken = this.store.getStoredImpersonateToken();
    if (!impersonateToken) return;
    this.store.removeImpersonateToken();
    this.api.deimpersonate(impersonateToken.id).subscribe(
      () => {
        this.impersonateToken = null;
        this.showSuccess('Deimpersonate User successfully.');
        window.location.assign('/service/dashboard');
      },
      error => {
        this.store.setImpersonateToken(impersonateToken);
        this.showError('Failed to  deimpersonate User');
      }
    );
  }

  showSuccess = (msg: string) => {
    this.toastrService.showSuccess(msg);
  };

  showWarning = (msg: string) => {
    this.toastrService.showWarning(msg);
  };

  showError = (msg: string) => {
    this.toastrService.showError(msg);
  };
}
